// extracted by mini-css-extract-plugin
export var dark = "Select-module--dark--c48ef";
export var form_group = "Select-module--form_group--7291a";
export var hasMarginTop = "Select-module--hasMarginTop--b07b3";
export var isSmall = "Select-module--isSmall--7aff5";
export var label = "Select-module--label--63ccd";
export var select = "Select-module--select--f1a0d";